import Api from "./Base";

export function requestResetPassword(data) {
    return Api.post("/forgot_password", data);
}

export function requestChangePassword(data) {
    return Api.post("/change_password", data);
}
